import axios from "axios";
import { SERVER_URL } from "../const";
import { D2D_API_URL, D2D_API_KEY } from "../const";
import Qs from 'qs';

export const getReturns = async (token) => {
  try {

    const response = await axios.get(SERVER_URL + "/returns", {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;

      return data;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
};


export const StdCertificateDataService = async (billType, token) => {
  try {

    const response = await axios.get(SERVER_URL + "/std-cert-data?bill_type=" + billType, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;

      return data;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
};

export const GetLatestStdCertificateDataService = async (billType, limit, token, iec_no = null) => {
  try {
    let url = SERVER_URL + "/std-cert-data/latest?bill_type=" + billType + "&limit=" + limit;
    if (iec_no) url += "&iec_no=" + iec_no;

    const response = await axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;

      return data;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
};

export const GetReturnsDataService = async (token, viewType, iec_no = null) => {
  try {
    let url = SERVER_URL + "/returns?view=" + viewType;
    if (iec_no) url += "&iec_no=" + iec_no;

    const response = await axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;
      return data;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
};

export const fileUploadStatusDataService = async (billType, token) => {
  try {
    const response = await axios.get(SERVER_URL + "/file-upload-status?bill_type=" + billType, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;
      console.log('API Response:', data);
      return data;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
};


export const updateBondDetailsService = async (bond_id, payload, token) => {
  return await axios.put(`${SERVER_URL}/bond-details/${bond_id}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
};

export const getAllAdminIECsService = async (token) => {
  try {
    const response = await axios.get(SERVER_URL + "/users/admin", {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;
      // console.log('API Response:', data);
      return data;
    } else {
      console.error('API Error:', response.statusText);
      // throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    // throw error;
  }
};

export const deleteFileDataService = async (token, file_status_id) => {
  try {
    const response = await axios.delete(SERVER_URL + "/file-upload-status/" + file_status_id, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      const data = response.data;
      // console.log('API Response:', data);
      return data;
    } else {
      console.error('API Error:', response.statusText);
      // throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    // throw error;
  }
};

export const getDashboardReportSummaryData = async (reportTypeList, filters, iec_no = null) => {
  try {
    const token = localStorage.getItem('token');
    const body = {
      report_type: reportTypeList,
      filters: filters
    };
    if (iec_no) body.iec_no = iec_no;
    const response = await axios.post(SERVER_URL + "/get-dashboard-report-summary",
      body,
      {
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      });

    if (response.status == 200) {
      return response;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
};

export const getReportSummaryData = async (reportType, filters, iec_no) => {
  try {
    const token = localStorage.getItem('token');
    // const url = `${SERVER_URL}/get-report-summary?report_type=${reportType}${
    //   filters.from_date && filters.to_date ? `&from_date=${filters.from_date}&to_date=${filters.to_date}` : ''
    // }`;

    let url = `${SERVER_URL}/get-report-summary?report_type=${reportType}&iec_no=${iec_no}`;

    if (filters.from_date && filters.to_date) {
      url += `&from_date=${filters.from_date}&to_date=${filters.to_date}`;
    }

    const response = await axios.get(url, {
      params: {
        br_code: filters.br_code && filters.br_code.length > 0
          ? filters.br_code
          : undefined,
        bill_no: filters.bill_no || undefined
      },
      paramsSerializer: params => {
        // This removes the brackets []
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status == 200) {
      return response;
    } else {
      console.error('API Error:', response.statusText);
      // throw new Error(response.statusText);
      return []
    }
  } catch (error) {
    console.error('Error:', error.message);
    // throw error;
  }
};

export const GetLicenseNoService = async (token, iec_no, billType) => {
  try {
    const response = await axios.get(SERVER_URL + "/licenses?iec_no=" + iec_no + "&bill_type=" + billType,
      {
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      });

    if (response.status === 200) {
      const data = response.data;
      // console.log('API Response:', data);
      return data;
    } else {
      console.error('API Error:', response.statusText);
      // throw new Error(response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
    // throw error;
  }
};

// to get export & import summary on compliance cards
export const downloadPendencySummary = async (token, fileType, skip, type = "CIP Compliance", excel_download = true, startDate = null, endDate = null, iec_no = null) => {
  try {
    let url = `${D2D_API_URL}/pendency-report-summary?report_type=${fileType}&type=${type}&excel_download=${excel_download}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (iec_no) url += `&iec_no=${iec_no}`;
    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-API-KEY': D2D_API_KEY,
      },
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const downloadConsolidatedReportService = async (token, iec_no, from_date, to_date) => {
  try {
    let url = `${SERVER_URL}/reports/consolidated-report/download`;
    const params = new URLSearchParams();
    if (iec_no) params.append('iec_no', iec_no);
    if (from_date) params.append('from_date', from_date);
    if (to_date) params.append('to_date', to_date);

    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error('Error in downloadConsolidatedReportService:', error);
    throw error;
  }
}

// Per-row drill-down for the Consolidated Summary Report. Returns records that
// reconcile exactly with the row's headline count/amount. format: 'json' | 'excel'.
export const getConsolidatedRowDetailService = async (srNo, iec_no, from_date, to_date, opts = {}) => {
  const token = localStorage.getItem('token');
  const { bondType = null, format = 'json' } = opts;
  const params = new URLSearchParams();
  params.append('sr_no', srNo);
  if (iec_no) params.append('iec_no', iec_no);
  if (from_date) params.append('from_date', from_date);
  if (to_date) params.append('to_date', to_date);
  if (bondType) params.append('bond_type', bondType);
  if (format) params.append('format', format);

  return axios.get(`${SERVER_URL}/reports/consolidated-report/row-detail?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
    ...(format === 'excel' ? { responseType: 'blob' } : {}),
  });
};

export const getConsolidatedReportPreviewDataService = async (token, iec_no, from_date, to_date) => {
  try {
    let url = `${SERVER_URL}/reports/consolidated-report/preview-data`;
    const params = new URLSearchParams();
    if (iec_no) params.append('iec_no', iec_no);
    if (from_date) params.append('from_date', from_date);
    if (to_date) params.append('to_date', to_date);

    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in getConsolidatedReportPreviewDataService:', error);
    throw error;
  }
}
// gets the sidebar report names
export const getReportNamesService = async (token) => {
  try {
    const response = await axios.get(`${SERVER_URL}/sidebar-reports-names`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

// fetch page configs for an IEC
export const getPageConfigService = async (iec_no) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${SERVER_URL}/page-config?iec_no=${iec_no}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching page config:', error);
    throw error;
  }
};

// save page configs for an IEC (superadmin only)
export const savePageConfigService = async (iec_no, page_name, configs) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${SERVER_URL}/page-config`, {
      iec_no,
      page_name,
      configs
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error saving page config:', error);
    throw error;
  }
};

export const getPartNumberMasterDataService = async ({ iec_no, part_number, hsn_code, page = 1, page_size = 50 } = {}) => {
  try {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({ page, page_size });
    if (iec_no) params.append('iec_no', iec_no);
    if (part_number) params.append('part_number', part_number);
    if (hsn_code) params.append('hsn_code', hsn_code);

    const response = await axios.get(`${SERVER_URL}/master-data/part-number?${params.toString()}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching part number master data:', error);
    throw error;
  }
};

export const getMasterHSNDataService = async ({ iec_no, part_number, hs_code, page = 1, page_size = 50 } = {}) => {
  try {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({ page, page_size });
    if (iec_no) params.append('iec_no', iec_no);
    if (part_number) params.append('part_number', part_number);
    if (hs_code) params.append('hs_code', hs_code);

    const response = await axios.get(`${SERVER_URL}/master-data/master-hsn?${params.toString()}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching master HSN data:', error);
    throw error;
  }
};

/**
 * Generic service to download filtered Excel reports directly from backend without page redirect.
 *
 * @param {string} reportType    - e.g. "EDPMS", "DBK-AIR", "IGST-Refund", etc.
 * @param {string} iec_no        - IEC number
 * @param {string} [category]    - Optional pendency category filter
 * @param {string} [from_date]   - YYYY-MM-DD
 * @param {string} [to_date]     - YYYY-MM-DD
 */
export const downloadDashboardReportService = async (reportType, iec_no, category, from_date, to_date, mode, coo_cos) => {
  const token = localStorage.getItem('token');
  const params = new URLSearchParams({ report_type: reportType, iec_no });
  if (category) params.append('pendency_category', category);
  if (from_date) params.append('from_date', from_date);
  if (to_date) params.append('to_date', to_date);
  if (mode && mode !== 'All') params.append('mode', mode);
  if (coo_cos && String(coo_cos).toUpperCase() !== 'ALL') params.append('coo_cos', coo_cos);

  const response = await axios.get(
    `${SERVER_URL}/reports/dashboard-report-download?${params.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    }
  );
  return response;
};

export const fetchDashboardReportJsonService = async (reportType, iec_no, category, from_date, to_date) => {
  const token = localStorage.getItem('token');
  const params = new URLSearchParams({ report_type: reportType, iec_no, format: 'json' });
  if (category) params.append('pendency_category', category);
  if (from_date) params.append('from_date', from_date);
  if (to_date) params.append('to_date', to_date);

  const response = await axios.get(
    `${SERVER_URL}/reports/dashboard-report-download?${params.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const downloadEdpmsPendencyService = async (iec_no, category, from_date, to_date) => {
  return downloadDashboardReportService('EDPMS', iec_no, category, from_date, to_date);
};